import { Hammer } from 'lucide-react';
import { cn } from '../../utils/formatters';

interface LoadingScreenProps {
  message?: string;
}

export function LoadingScreen({ message = 'Cargando...' }: LoadingScreenProps) {
  return (
    <div className="min-h-screen flex items-center justify-center bg-secondary-50 dark:bg-secondary-950">
      <div className="flex flex-col items-center gap-4">
        <div className="relative">
          <div className="w-16 h-16 rounded-full border-4 border-primary-200 dark:border-primary-800 border-t-primary-600 animate-spin" />
          <div className="absolute inset-0 w-16 h-16 rounded-full border-4 border-primary-200 dark:border-primary-800 border-r-primary-600 animate-spin reverse" style={{ animationDuration: '2s' }} />
          <Hammer className="absolute inset-0 w-8 h-8 m-auto text-primary-600 dark:text-primary-400" />
        </div>
        <p className="text-secondary-600 dark:text-secondary-400 text-sm font-medium">{message}</p>
      </div>
    </div>
  );
}

export function PageLoading({ message = 'Cargando...' }: LoadingScreenProps) {
  return (
    <div className="flex items-center justify-center py-12">
      <div className="flex flex-col items-center gap-3">
        <div className="w-8 h-8 rounded-full border-3 border-primary-200 dark:border-primary-800 border-t-primary-600 animate-spin" />
        <p className="text-secondary-500 dark:text-secondary-400 text-sm">{message}</p>
      </div>
    </div>
  );
}

export function Skeleton({ className = '' }: { className?: string }) {
  return (
    <div className={cn('skeleton', className)} />
  );
}

export function CardSkeleton() {
  return (
    <div className="card p-6 space-y-4 animate-pulse">
      <div className="h-4 w-3/4 bg-secondary-200 dark:bg-secondary-700 rounded" />
      <div className="h-4 w-1/2 bg-secondary-200 dark:bg-secondary-700 rounded" />
      <div className="h-4 w-full bg-secondary-200 dark:bg-secondary-700 rounded" />
      <div className="h-4 w-2/3 bg-secondary-200 dark:bg-secondary-700 rounded" />
    </div>
  );
}

export function ListSkeleton({ count = 5 }: { count?: number }) {
  return (
    <div className="space-y-4">
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} className="card p-4 flex items-center gap-4 animate-pulse">
          <div className="w-12 h-12 rounded-lg bg-secondary-200 dark:bg-secondary-700" />
          <div className="flex-1 space-y-2">
            <div className="h-4 w-3/4 bg-secondary-200 dark:bg-secondary-700 rounded" />
            <div className="h-3 w-1/2 bg-secondary-200 dark:bg-secondary-700 rounded" />
          </div>
        </div>
      ))}
    </div>
  );
}